import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CardDetailController } from "./card-detail-controller";
import { CardDetailPage } from "./card-detail-page";

export function CardDetailRoute({ deps }: { deps: AppDeps }) {
  const { cardId = "" } = useParams<{ cardId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  // A customer's confirmed scan opens its card with what the customer was quoted; a Stock row's menu, at a section.
  const opened = location.state as { quoteNote?: string; section?: string } | null;
  const quoteNote = opened?.quoteNote ?? null;
  const section = opened?.section === "price" || opened?.section === "history" ? opened.section : null;
  return (
    <Subtree
      key="card-detail"
      deps={[cardId]}
      controller={() =>
        new CardDetailController(
          pick(deps, "client", "authHandler", "storeRepository", "stockListRepository"),
          cardId,
          {
            back: () => navigate(-1),
            // Archived, the card closes back to the list it was opened from, as iOS's sheet does; opened on its own,
            // to Stock in its place.
            toCards: () => (location.key === "default" ? navigate("/cards", { replace: true }) : navigate(-1)),
          },
          { quoteNote, section },
        )
      }
    >
      <CardDetailPage />
    </Subtree>
  );
}
